module.exports = __webpack_public_path__ + "static/media/Ayar-01.4013bfd7.svg";